import styled, { keyframes } from "styled-components";

// ============================================================================
// ANIMATIONS
// ============================================================================

export const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

// ============================================================================
// MODAL STRUCTURE
// ============================================================================

export const Overlay = styled.div.attrs({ className: 'modal-designacao-overlay' })`
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.18);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ModalBox = styled.div.attrs({ className: 'modal-designacao-box' })`
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.12);
  width: 570px;
  max-width: 98vw;
  padding: 0; /* Changed from 0 28px 30px 28px */
  position: relative;
  max-height: 90vh; /* Increased */
  display: flex;
  flex-direction: column;
`;

export const CloseButton = styled.button.attrs({ className: 'modal-designacao-closebutton' })`
  position: absolute;
  top: 18px;
  right: 18px;
  background: none;
  border: none;
  font-size: 16px;
  cursor: pointer;
  color: #888;
  z-index: 10;
`;

// ============================================================================
// HEADER
// ============================================================================

export const ModalHeader = styled.div.attrs({ className: 'modal-designacao-header' })`
  padding: 19px 28px 0 28px;
  display: flex;
  flex-direction: column;
`;

export const TopBar = styled.div.attrs({ className: 'modal-designacao-topbar' })`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  & > div {
    display: flex;
    align-items: center;

    @media (max-width: 600px) {
      flex-direction: row;
      align-items: stretch;
      width: 100%;
      gap: 8px;
    }
  }
`;

export const PageInfo = styled.div.attrs({ className: 'modal-designacao-pageinfo' })`
  font-size: 15px;
  color: #444;
  white-space: nowrap;
`;

export const SectionTitle = styled.div.attrs({ className: 'modal-designacao-sectiontitle' })`
  background: #00aaaa;
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  padding: 8px 32px;
  margin-bottom: 0;
  margin-top: 10px;
`;

// ============================================================================
// SEARCH
// ============================================================================

export const SearchBox = styled.div.attrs({ className: 'modal-designacao-searchbox' })`
  display: flex;
  align-items: center;
  background: #f5f5f5;
  border-radius: 8px;
  padding: 0 10px;
  height: 32px;
  min-width: 180px;
  margin-left: 8px;

  @media (max-width: 600px) {
    margin-left: 0;
  }
`;

export const FilterSelect = styled.select.attrs({ className: 'modal-designacao-filterselect' })`
  height: 32px;
  border-radius: 8px;
  border: 1px solid #ccc;
  background: #f5f5f5;
  font-size: 14px;
  padding: 0 10px;
  outline: none;
  color: #444;
`;

export const SearchInput = styled.input.attrs({ className: 'modal-designacao-searchinput' })`
  border: none;
  background: transparent;
  font-size: 14px;
  flex: 1;
  outline: none;
  padding: 0 6px;
`;

// ============================================================================
// CARD (PUBLICADOR)
// ============================================================================

export const Card = styled.div.attrs({ className: 'modal-designacao-card' })`
  background: #fff;
  border-radius: 12px;
  border: 1px solid #eee;
  margin: 24px 32px 0 32px;
  padding: 18px 22px 18px 22px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0;

  .modal-designacao-selectbutton {
    align-self: flex-end;
  }
`;

export const CardTitle = styled.div.attrs({ className: 'modal-designacao-cardtitle' })`
  color: #008080;
  font-size: 17px;
  font-weight: 500;
  margin-bottom: 12px;
`;

export const CardInfo = styled.div.attrs({ className: 'modal-designacao-cardinfo' })`
  font-size: 14px;
  color: #736868;
  margin-bottom: 8px;
`;

export const CardLabel = styled.span.attrs({ className: 'modal-designacao-cardlabel' })`
  font-weight: 500;
  color: #4B5563;
`;

export const ObservationBadge = styled.span.attrs({ className: 'modal-designacao-observation-badge' })`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #d93a3a;
  color: #fff;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 700;
  padding: 2px 6px;
  margin-left: 8px;
  justify-self: start;
  width: fit-content;
`;

export const AbsenceDetailsBox = styled.div.attrs({ className: 'modal-designacao-absence-details' })`
  background: #fafafa;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  padding: 5px 8px;
  margin-top: 5px;
  margin-left: 0;
  font-size: 11px;
  color: #333;
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: fit-content;
  justify-self: start;
`;

export const AbsenceDetailRow = styled.div.attrs({ className: 'modal-designacao-absence-detail-row' })`
  display: flex;
  gap: 5px;
  font-size: 11px;
  color: #555;
  align-items: baseline;
  line-height: 1.3;
  height: auto;
  padding: 1px 0;
`;

export const AbsenceDetailLabel = styled.span.attrs({ className: 'modal-designacao-absence-detail-label' })`
  font-weight: 600;
  color: #333;
  white-space: nowrap;
  font-size: 11px;
  flex-shrink: 0;
`;

export const CardListScroll = styled.div.attrs({ className: 'modal-designacao-cardlist-scroll' })`
  flex: 1;
  overflow-y: auto;
  min-height: 0;
  margin-bottom: 0;
  padding: 10px 28px;
`;

// ============================================================================
// DISPONIBILIDADE
// ============================================================================

export const DisponibilidadeWrapper = styled.div.attrs({ className: 'modal-designacao-disponibilidadewrapper' })`
  display: flex;
  gap: 18px;
  margin-bottom: 10px;
`;

export const DisponibilidadeCard = styled.div.attrs({ className: 'modal-designacao-disponibilidadecard' })`
  background: #f9f9f9;
  border-radius: 8px;
  border: 1px solid #eee;
  padding: 10px 14px;
  min-width: 170px;
`;

export const DispTitle = styled.div.attrs({ className: 'modal-designacao-disptitle' })`
  font-size: 13px;
  color: #888;
  font-weight: 500;
  margin-bottom: 2px;
`;

export const DispInfo = styled.div.attrs({ className: 'modal-designacao-dispinfo' })`
  font-size: 14px;
  color: #444;
  margin-bottom: 2px;
`;

export const DispSub = styled.div.attrs({ className: 'modal-designacao-dispsub' })`
  font-size: 13px;
  color: #666;
`;

// ============================================================================
// BUTTONS
// ============================================================================

export const SelectButton = styled.button.attrs({ className: 'modal-designacao-selectbutton' })`
  background: ${props => props.disabled ? '#b5b5b5' : '#25D366'};
  color: ${props => props.disabled ? '#f5f5f5' : '#fff'};
  border: none;
  border-radius: 8px;
  padding: 8px 18px;
  font-size: 12px;
  font-weight: 500;
  margin-top: 10px;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: ${props => props.disabled ? 'none' : '0 2px 8px rgba(0,0,0,0.04)'};
  transition: background .2s;
  &:hover { background: ${props => props.disabled ? '#b5b5b5' : '#009e6d'}; }
`;

export const NextButton = styled.button.attrs({ className: 'modal-designacao-nextbutton' })`
  background: #25B89A;
  color: #fff;
  border: none;
  border-radius: 12px;
  padding: 8px 10px 8px 20px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  transition: background .2s;
  display: flex;
  align-items: center;
  gap: 10px;
  &:hover { background: #1CA885; }
`;

export const PrevButton = styled(NextButton).attrs({ className: 'modal-designacao-prevbutton' })``;

// ============================================================================
// MESSAGES
// ============================================================================

export const LimitMessage = styled.div.attrs({ className: 'modal-designacao-limit-message' })`
  color: #b3261e;
  font-size: 13px;
  font-weight: 500;
  margin-top: 10px;
  line-height: 1.4;
`;

// ============================================================================
// FOOTER / PAGINATION
// ============================================================================

export const Footer = styled.div.attrs({ className: 'modal-designacao-footer' })`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 32px 12px 32px;
  margin-top: 18px;
`;

export const PaginationBar = styled.div.attrs({ className: 'modal-designacao-paginationbar' })`
  display: grid;
  grid-auto-flow: column;
  justify-content: space-between;
  align-items: center;
  gap: 18px;
  padding: 10px 32px;
  margin-top: auto; /* Push it to bottom conceptually if not filled */
`;

// ============================================================================
// LOADING STATE
// ============================================================================

export const ContainerCarregando = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 60px 20px;
  min-height: 200px;
`;

export const Spinner = styled.div`
  width: 20px;
  height: 20px;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #008080;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

export const MensagemCarregando = styled.p`
  font-family: 'Roboto', sans-serif;
  font-size: 16px;
  color: #666;
  margin: 0;
  text-align: center;
`;
